module.exports = __webpack_public_path__ + "img/about-img_1-min.8e548381.jpg";